export default "__VITE_ASSET__C2D8UzKV__"